export default Object.freeze({
	IsActivated: 'IsActivated',
	Success: 'Success',
	InReview: 'IN-REVIEW',
	OnboardingRequired:
		'Hello! You need to complete your Onboarding to access this feature',
	Failed: 'Failed',
	LIMIT_EXCEEDED:
		'Account limit is exceeded for this transaction, kindly contact the Admin',
	TokenSent: 'Token Sent',
	RouteParams: 'RouteParams',
	business: 'business',
	walletBalance: 'walletBalance',
	TransactionsSummary: 'TransactionsSummary',
	walleTransferLimit: 'walleTransferLimit',
	OfflineTransactions: 'OfflineTransactions',
	WalletTransactions: 'WalletTransactions',
	WeekSummary: 'WeekSummary',
	NewBeneficiaryPayload: 'NewBeneficiaryPayload',
	SavedBeneficiaryPayload: 'SavedBeneficiaryPayload',
	TransferPayload: 'TRANSFERPAYLOAD',
	Banks: 'Banks',
	Sent: 'Sent',
	INVALID_PIN: 'Invalid Pin',
	SET_UP_PIN: 'Please set your pin to use this feature',
	LOW_WALLET_BALANCE: 'Account balance is low, kindly top up',
	Beneficiaries: 'Beneficiaries',
	MakerCheckerUserType: {
		REQUESTER: 'REQUESTER',
		REVIEWER: 'REVIEWER',
		APPROVER: 'APPROVER',
	},
	CATEGORY: {
		WALLET: 'WALLET',
		OFFLINE: 'OFFLINE',
	},
	TRANSACTION_TYPE: {
		EXPENSE: 'EXPENSE',
		INCOME: 'INCOME',
	},
	STATUS: {
		APPROVED: 'APPROVED',
		PENDING: 'PENDING',
		VOID: 'VOID',
		FAILED: 'FAILED',
		PAID: 'PAID',
		IGNORE: 'IGNORED',
		IN_REVIEW: 'IN REVIEW',
		REVIEWED: 'REVIEWED',
		PARTIALLY_REVIEWED: 'PARTIALLY REVIEWED',
		REQUEST_CHANGE: 'REQUEST CHANGE',
		PROCESSING: 'PROCESSING',
		REVERSED: 'REVERSED',
	},
	TRANSACTION_STATUS: {
		PAID: 'PAID',
		VOID: 'VOID',
		UNPAID: 'UNPAID',
		PARTIALLY_PAID: 'PARTIALLY-PAID',
		FULLY_PAID: 'FULLY-PAID',
	},
	QUOTATION_STATUS: {
		DRAFT: 'DRAFT',
		VOID: 'VOID',
		ORDERED: 'ORDERED',
		EXPIRED: 'EXPIRED',
	},
	MissingWithdrawalAccount: 'Kindly Setup Your Withdrawal Account',
	RoutePath: 'RoutePath',
	Routes: {
		Home: '/login',
		Login: '/login',
		SignUp: '/signup',
		ForgetPassword: '/forgot-password',
		Otp: '/otp',
		ResetPassword: '/reset-password',
		ResetPasswordChangeSuccess: '/reset-password-success',
		SignUpVerify: '/signup-verify',
		OnboardingStageOne: '/onboarding-stage-one',
		OnboardingStageTwo: '/onboarding-stage-two',
		AlmostThereThree: '/almost-there-three',
		AppHome: '/home',
		Wallet: '/wallet',
		Booking: '/booking',
		Customer: '/customer',
		Invoice: '/invoice',
		Transactions: '/transactions',
		TransactionsNew: '/transactions/new',
		Receipt: '/receipt',
		Settings: '/settings',
		Error404: '/error-404',
		Billing: '/billing',
		// Checkout: '/checkout',

		//ProductDisplay: 'product-display',
		EditModal: '/editModal',
		AccountInReview: '/account-in-review',
		PaymentLink: '/payment-link',
		PaymentLinkCheckout: '/payments/:id',
		Faqs: '/faqs',
		MakeBookings: '/bookings/:id',
		Contact: '/contact',
		Sitemap: '/sitemap_index.xml',
		ApiKeys: '/api-keys',
		ViewMoreDesign: '/view-more-design',
		FxTransferCheckout: '/fx-transfer-checkout',
	},
	IsOnBoardingDone: 'IsOnBoardingDone',
	OtpType: {
		FORGETPASSWORD: 'FORGETPASSWORD',
		ONBOARDING: 'ONBOARDING',
		BVNONBOARDING: 'BVNONBOARDING',
	},
	PLAN_STATUS: {
		ACTIVE: 'ACTIVE',
		LOCKED: 'LOCKED',
		EXPIRED: 'EXPIRED',
	},

	FEEDBACK: {
		CUSTOMERCREATE: 'CUSTOMER-CREATE',
		CUSTOMERUPDATE: 'CUSTOMER-UPDATE',
		INVOICECREATE: 'INVOICE-CREATE',
		INVOICEUPDATE: 'INVOICE-UPDATE',
		INVOICEEDIT: 'INVOICE-EDIT',
		RECEIPTCREATE: 'RECEIPT-CREATE',
		WALLETCREATEVIRTUALBUSINESSBANKACCOUNT:
			'WALLET-CREATE-VIRTUAL-BUSINESS-BANK-ACCOUNT',
		WALLETWITHDRAWAL: 'WALLET-WITHDRAWAL',
		WALLETMAKEPAYMENT: 'WALLET-MAKE-PAYMENT',
		WALLETEXCHANGE: 'WALLET-EXCHANGE',

		BOOKINGCREATE: 'BOOKING-CREATE',
		BOOKINGEDIT: 'BOOKING-EDIT',
		PAYMENTLINKCREATE: 'PAYMENT-LINK-CREATE',
		PAYMENTLINKEDIT: 'PAYMENT-LINK-EDIT',
		TRANSACTIONSTAG: 'TRANSACTIONS-TAG',
		MULTITENANCYADD: 'MULTI-TENANCY-ADD',
		BUSINESSREPORTDOWNLOAD: 'BUSINESS-REPORT-DOWNLOAD',
	},

	FLOW_TYPE: {
		All: 'All',
		Income: 'Income',
		Funding: 'Funding',
		Expense: 'Expense',
		Withdraw: 'Withdraw',
		Refund: 'Refund',
		Untagged: 'Untagged',
		Investment: 'Investment',
		Gifts: 'Gifts',
		Assets: 'Assets',
		Loan: 'Loan',
	},

	apiQueryKey: {
		Transactions: {
			TransactionList: 'transactionList',
		},
		subscriptionPlans: 'SUB-PLANS',
		subscriptions: 'SUBS',
		subscriptionPayments: 'SUBS-PAYMENTS',
	},
	events: {
		add_to_cart: 'add_to_cart',
		initiate_checkout: 'initiate_checkout',
		checkout: 'checkout',
		lead: 'lead',
		page_visit: 'page_visit', // use for product viewed
		search: 'search',
		intent_login: 'intent_login',
		intent_signup: 'intent_signup',
		signup_complete: 'signup_complete',
		login_success: 'login_success',
	},
});
